document.addEventListener("DOMContentLoaded", function () {
  // LOADER
  const loader = document.querySelector("[data-loader]");

  function hideLoader() {
    loader.classList.add("hide");
  }

  window.addEventListener("load", hideLoader);
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      hideLoader();
    }
  });

  document.addEventListener("click", (e) => {
    const link = e.target.closest("a");

    if (!link) return;

    const href = link.getAttribute("href");
    const isSameHost = link.hostname === window.location.hostname;
    const isAnchorLink = href && href.startsWith("#");

    if (
      link.target === "_blank" ||
      !isSameHost ||
      isAnchorLink ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:")
    ) {
      return;
    }

    e.preventDefault();
    loader.classList.remove("hide");

    setTimeout(() => {
      window.location.href = href;
    }, 200);
  });

  // CART
  function UpdateCartItemCounts(count) {
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = count;
    });
  }

  async function updateCartDrawer() {
    const res = await fetch(
      window.Shopify.routes.root + "?section_id=cart-drawer",
    );
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;

    addCartDrawerListeners();
  }

  function addCartDrawerListeners() {
    // Open and close cart drawer
    const cartContainer = document.querySelector("[data-cart-container]");
    const openCart = document.querySelector("[data-cart-open]");
    const closeCart = document.querySelectorAll("[data-cart-close]");
    const body = document.querySelector("body");
    const cartLoading = document.querySelector("[data-cart-loading]");

    cartLoading.classList.remove("active");

    openCart.addEventListener("click", function () {
      cartContainer.classList.add("active");
      body.classList.add("no-scroll");
    });

    closeCart.forEach((close) => {
      close.addEventListener("click", function () {
        cartContainer.classList.remove("active");
        body.classList.remove("no-scroll");
      });
    });

    // Update quantity
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Show loading
          cartLoading.classList.add("active");

          // Get line item key
          const key = button.parentElement.getAttribute("data-line-item-key");

          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.querySelector("input").value,
          );
          const isUp = button.classList.contains("cart-drawer-quantity-plus");
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

          // Ajax update
          const res = await fetch(
            window.Shopify.routes.root + "cart/update.js",
            {
              method: "post",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: {
                  [key]: newQuantity,
                },
              }),
            },
          );

          const cart = await res.json();

          UpdateCartItemCounts(cart.item_count);

          // Update cart
          updateCartDrawer();
        });
      });

    // Remove item
    document.querySelectorAll(".cart-drawer-remove").forEach((button) => {
      button.addEventListener("click", async () => {
        // Show loading
        cartLoading.classList.add("active");

        // Get line item key
        const key = button.getAttribute("data-line-item-key");

        // Ajax update
        const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            updates: {
              [key]: 0,
            },
          }),
        });

        const cart = await res.json();

        UpdateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

    // Add add-on
    document.querySelectorAll(".cart-drawer-add-on").forEach((button) => {
      button.addEventListener("click", async () => {
        // Show loading
        cartLoading.classList.add("active");

        // Get line item key
        const key = button.dataset.variantId;

        let items = [
          {
            id: key,
            quantity: 1,
          },
        ];

        // Submit form with Ajax
        await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });

        // Get cart count
        const res = await fetch(window.Shopify.routes.root + "cart.js");
        const cart = await res.json();

        UpdateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });
  }

  addCartDrawerListeners();

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const button = document.querySelector("#add-to-cart-btn");
      const originalText = button.innerText;
      button.innerText = "Ajouté";
      button.disabled = true;

      const formData = new FormData(form);
      const mainProduct = formData.get("id");
      const maintProductQuantity = parseInt(formData.get("quantity")) || 1;

      let items = [
        {
          id: mainProduct,
          quantity: maintProductQuantity,
        },
      ];

      // Add-on
      const addonInput = document.querySelector(".addon-checkbox");
      if (addonInput && addonInput.checked) {
        items.push({
          id: addonInput.dataset.addonId,
          quantity: 1,
        });
      }

      // Submit form with Ajax
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      // Get cart count
      const res = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await res.json();

      UpdateCartItemCounts(cart.item_count);

      // Update cart
      await updateCartDrawer();

      // Open cart drawer
      document.querySelector("[data-cart-container]").classList.add("active");
      document.querySelector("body").classList.add("no-scroll");

      button.innerText = originalText;
      button.disabled = false;
    });
  });

  gsap.registerPlugin(ScrollTrigger, SplitText);

  // ANIMATION SECTIONS
  document.fonts.ready.then(() => {
    initAnimations();
  });

  function initAnimations() {
    const animationSections = document.querySelectorAll(
      "[data-animate-section]",
    );

    if (animationSections.length !== 0) {
      animationSections.forEach((section) => {
        const elements = section.querySelectorAll("[data-animate-element]");

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top bottom-=50",
          },
        });

        elements.forEach((el, index) => {
          const type = el.dataset.animateElement;

          if (type === "split") {
            const split = SplitText.create(el, {
              type: "words",
              wordsClass: "word++",
              mask: "words",
            });

            if (index === 0) {
              tl.from(split.words, {
                yPercent: 200,
                stagger: 0.2 / split.words.length,
                duration: 0.8,
                ease: "power3.out",
              });
            } else {
              tl.from(
                split.words,
                {
                  yPercent: 200,
                  stagger: 0.2 / split.words.length,
                  duration: 0.8,
                  ease: "power3.out",
                },
                "-=0.8",
              );
            }
          } else if (type === "fade") {
            if (index === 0) {
              tl.from(el, {
                y: "50px",
                opacity: 0,
                duration: 0.8,
                ease: "power3.out",
              });
            } else {
              tl.from(
                el,
                {
                  y: "50px",
                  opacity: 0,
                  duration: 0.8,
                  ease: "power3.out",
                },
                "-=0.6",
              );
            }
          } else if (type === "line") {
            if (index === 0) {
              tl.from(el, {
                scaleX: "0",
                duration: 0.8,
                ease: "power3.out",
              });
            } else {
              tl.from(
                el,
                {
                  scaleX: "0",
                  duration: 0.8,
                  ease: "power3.out",
                },
                "-=0.6",
              );
            }
          } else if (type === "scale") {
            if (index === 0) {
              tl.from(el, {
                scale: "0",
                duration: 0.8,
                ease: "power3.out",
              });
            } else {
              tl.from(
                el,
                {
                  scale: "0",
                  duration: 0.8,
                  ease: "power3.out",
                },
                "-=0.6",
              );
            }
          } else if (type === "clip") {
            if (index === 0) {
              tl.fromTo(
                el,
                {
                  clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
                },
                {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  duration: 1.3,
                  ease: "power3.out",
                },
              );
            } else {
              tl.fromTo(
                el,
                {
                  clipPath: "polygon(0 0, 100% 0, 100% 0, 0 0)",
                },
                {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  duration: 1.3,
                  ease: "power3.out",
                },
                "-=1.1",
              );
            }
          } else if (type === "image") {
            if (index === 0) {
              tl.from(el, {
                scale: "1.3",
                duration: 0.8,
                ease: "power3.out",
              });
            } else {
              tl.from(
                el,
                {
                  scale: "1.3",
                  duration: 0.8,
                  ease: "power3.out",
                },
                "-=0.6",
              );
            }
          }
        });
      });
    }
  }

  // FAQ
  const faqContainers = document.querySelectorAll("[data-faq-container]");

  if (faqContainers.length !== 0) {
    faqContainers.forEach((faqContainer) => {
      const faqQuestion = faqContainer.querySelector("[data-faq-question]");

      faqQuestion.addEventListener("click", function () {
        const isActive = faqContainer.classList.contains("active");

        faqContainers.forEach((container) => {
          container.classList.remove("active");
        });

        if (!isActive) {
          faqContainer.classList.add("active");
        }
      });
    });
  }

  // DEALERS
  const dealerContainers = document.querySelectorAll("[data-dealer-container]");

  if (dealerContainers.length !== 0) {
    dealerContainers.forEach((dealerContainer) => {
      dealerTitle = dealerContainer.querySelector("[data-dealer-title]");

      dealerTitle.addEventListener("click", function () {
        dealerContainer.classList.toggle("active");
      });
    });
  }

  //PRODUCT IMAGE
  const productFeaturedImage = document.querySelector(
    "[data-product-featured-image]",
  );
  const productImages = document.querySelectorAll("[data-product-image]");
  const productImagesPrev = document.querySelector("[data-product-image-prev]");
  const productImagesNext = document.querySelector("[data-product-image-next]");

  if (productFeaturedImage && productImages.length > 0) {
    let currentIndex = 0;

    // Fonction pour afficher l'image par index
    function showImage(index) {
      // Boucle infinie
      if (index < 0) index = productImages.length - 1;
      if (index >= productImages.length) index = 0;
      currentIndex = index;

      gsap.to(productFeaturedImage, {
        duration: 0.2,
        ease: "power3.out",
        opacity: 0,
        onComplete: function () {
          productFeaturedImage.src =
            productImages[currentIndex].dataset.productImage;
          productFeaturedImage.style.objectFit =
            productImages[currentIndex].dataset.productSize;

          gsap.to(productFeaturedImage, {
            duration: 0.3,
            ease: "power3.out",
            opacity: 1,
          });
        },
      });

      // Mettre à jour la classe active sur les miniatures
      productImages.forEach((img, i) => {
        img.classList.toggle("active", i === currentIndex);
      });
    }

    // Click sur les miniatures
    productImages.forEach((productImage, index) => {
      productImage.addEventListener("click", function () {
        showImage(index);
      });
    });

    // Bouton suivant
    if (productImagesNext) {
      productImagesNext.addEventListener("click", function () {
        showImage(currentIndex + 1);
      });
    }

    // Bouton précédent
    if (productImagesPrev) {
      productImagesPrev.addEventListener("click", function () {
        showImage(currentIndex - 1);
      });
    }

    // Affichage de l'image initiale
    showImage(0);
  }

  // PRODUCT DRAWERS
  const productDrawerContainers = document.querySelectorAll(
    "[data-product-drawer-container]",
  );

  if (productDrawerContainers.length !== 0) {
    productDrawerContainers.forEach((productDrawerContainer) => {
      const productDrawerTitle = productDrawerContainer.querySelector(
        "[data-product-drawer-title]",
      );

      productDrawerTitle.addEventListener("click", function () {
        const isActive = productDrawerContainer.classList.contains("active");

        productDrawerContainers.forEach((container) => {
          container.classList.remove("active");
        });

        if (!isActive) {
          productDrawerContainer.classList.add("active");
        }
      });
    });
  }

  // SERVICES
  const serviceContainers = document.querySelectorAll(
    "[data-service-container]",
  );

  if (serviceContainers.length !== 0) {
    serviceContainers[1].classList.add("active");
    serviceContainers.forEach((serviceContainer) => {
      serviceContainer.addEventListener("mouseenter", function () {
        serviceContainers.forEach((otherServiceContainer) => {
          if (otherServiceContainer !== serviceContainer) {
            otherServiceContainer.classList.remove("active");
          }
        });

        serviceContainer.classList.add("active");
      });
    });
  }

  // OPEN CLOSE MOBILE MENU
  const header = document.querySelector("[data-header]");
  const menuContainer = document.querySelector("[data-menu-container]");
  const toggleMenu = document.querySelector("[data-menu-toggle]");

  toggleMenu.addEventListener("click", function () {
    menuContainer.classList.toggle("active");
    header.classList.toggle("menu-opened");
    body.classList.toggle("no-scroll");
  });

  // HEADER CLASSES
  let scrollPosition = 0;
  let lastScrollPosition = 0;

  window.addEventListener("scroll", (e) => {
    scrollPosition = window.scrollY;

    if (scrollPosition < 250) {
      header.classList.remove("small");
    } else {
      header.classList.add("small");
    }

    let st = window.pageYOffset || document.documentElement.scrollTop;

    if (st > lastScrollPosition && scrollPosition > 750) {
      header.classList.add("hide");
    } else {
      header.classList.remove("hide");
    }

    lastScrollPosition = st <= 0 ? 0 : st;
  });

  // TOGGLE FAQ FILTERS
  const faqFiltersContainer = document.querySelector(
    "[data-faq-filters-container]",
  );
  const faqFiltersToggle = document.querySelector("[data-faq-filters-toggle]");
  const faqFilters = document.querySelectorAll("[data-faq-filter]");

  if (faqFiltersContainer) {
    faqFiltersToggle.addEventListener("click", function () {
      faqFiltersContainer.classList.toggle("active");
    });

    faqFilters.forEach((faqFilter) => {
      faqFilter.addEventListener("click", function () {
        faqFiltersContainer.classList.remove("active");
      });
    });
  }

  // TOGGLE PRODUCTS FILTERS
  const productsFiltersContainer = document.querySelector(
    "[data-products-filters-container]",
  );
  const productsFiltersToggle = document.querySelector(
    "[data-products-filters-toggle]",
  );

  if (productsFiltersContainer) {
    productsFiltersToggle.addEventListener("click", function () {
      productsFiltersContainer.classList.toggle("active");
    });
  }

  const params = new URLSearchParams(window.location.search);

  if (params.get("open_cart") === "true") {
    document.querySelector("[data-cart-open]").click();
  }
});
